import CommunicationConst from "../communication-const";
import type {
  TCommunicationTab,
  TCommunicationTask,
} from "./communication-types-helper";

export const getCommunicationOpenActionLabelKey = (
  task: TCommunicationTask,
  currentTab: TCommunicationTab
): string => {
  if (
    currentTab === "audit"
    || task.status === CommunicationConst.statuses.APPROVED
    || task.status === CommunicationConst.statuses.DISMISSED
  ) {
    return "COMMUNICATION.Button_View";
  }

  if (task.status === CommunicationConst.statuses.UNIDENTIFIED) {
    return "COMMUNICATION.Button_StartMatch";
  }

  return "COMMUNICATION.Button_StartReview";
};
